import SECOND from "../assets/Patito-2nd.png";
import OG from "../assets/Patito-OG.png";
import HELL from "../assets/Patito-Hell.png";

// TODO: Add
const UPSIDE_CONTRACT_ADDRESS = "0xc6426937d6ef8db8ea49e3c0fda3bf0f24ebd561";
const HELL_CONTRACT_ADDRESS = "0x7b7dad77e4090160f9cb6ba57a5a774c12d4c28a";
const OG_CONTRACT_ADDRESS = "0x0f4b28d46cab209bc5fa987a92a26a5680538e45";

const rubberDucks = {
  'noncoducks2gen': SECOND,
  'nonconformistducks': OG,
  'nonconformisthellducks': HELL
};

export {
  rubberDucks,
  UPSIDE_CONTRACT_ADDRESS,
  OG_CONTRACT_ADDRESS,
  HELL_CONTRACT_ADDRESS
};